<app-change-password-form [type]="type"></app-change-password-form>
